import "./prasora-home-page-menu.scss";
import "./prasora-header.scss";
import m from "mithril";
import RC from "../../plugins/responsive-component/responsive-component";
import svg from "../../svg";
import html2canvas from "../../external-libraries/html2canvas/src/index";
import pf from "../../pf";
import localforage from "localforage";
import tools from "../../tools/tools";
import push from "../notification-manager/push";
import recorder from "./recorder";
import player from "./player";
import helpcomp from "./help-component";
import fileuploadcounter from "../../file-upload-counter/file-upload-counter.js";
import ClearEverything from "../../cleareverything";
import hslcolorpicker from "./hsl-color-picker/hsl-color-picker";
import drawableCanvas from "../drawable-canvas/drawable-canvas";
import PrasoraSplash from "../../../app/splash-page/splash-page.js";

const segmenter = new Intl.Segmenter({
	granularity: "letter",
});

export default () => {
	let showcolorpicker = false;
	let showMenu = false;
	let menu = null;
	let localmode = false;
	let homepagelink = null;
	let homedata = null;
	let client = null;
	let isloggedin = false;
	let showfullmenu = false;
	let allow_notification = false;
	let sharingIsOn = false;
	let sharedCanvas = null;
	let shareMessage = null;
	let notification_link = null;
	let not_notified = false;
	let shownotificationrequest = false;
	let showplayerreview = false;
	let showhelpsection = false;
	let recordedevents = null;
	let helpModuleEnabled = true;
	let helpEditEnabled = false;
	let pagecode = undefined;

	function ShouldShowNotificationPermission(postpone, duration) {
		const key = "hide-prasora-notification-request";
		if (postpone) {
			shownotificationrequest = false;
			let expire = Math.round((duration || 30 * 24 * 60 * 60 * 1000) + Date.now());
			localforage.setItem(key, expire);
		} else {
			if (isloggedin) {
				if (pf.HasNotificationPermission()) {
					push.GetSubscription();
				} else {
					if (not_notified)
						if (window.location.href != notification_link) {
							if (notification_link) {
								localforage.getItem(key).then((expire) => {
									// console.log({ expire, now: Date.now() });
									let wait = false;
									if (expire) {
										if (expire < Date.now()) {
											wait = true;
										}
									} else {
										wait = true;
									}

									if (wait) shownotificationrequest = true;

									m.redraw();
								});
							}
						}
				}
			}
		}
	}

	async function OnShare() {
		sharingIsOn = true;
		m.redraw();
		html2canvas(document.body).then(function (canvas) {
			if (canvas) {
				var jpegRawData = canvas.toDataURL("image/jpeg", 1.0); //.replace("data:image/jpeg;base64,", "");
				sharedCanvas = jpegRawData;
			}
			m.redraw();
		});
	}

	return {
		oninit: (v) => {
			// console.log(v.attrs);
			let finalObj = JSON.parse(v.attrs.menu);
			// console.log(finalObj);
			menu = finalObj.menu;
			homepagelink = finalObj.homelink;
			localmode = finalObj.localmode;
			showfullmenu = finalObj.showfullmenu;
			pf.unreadnotifications(parseInt(finalObj.unread_notifications));
			homedata = finalObj.homedata;
			client = finalObj.client;
			isloggedin = finalObj.loggedin;
			not_notified = finalObj.not_notified;
			showfullmenu = false;
			allow_notification = finalObj.allow_notification;
			pagecode = finalObj.pagecode;
			notification_link = finalObj.notification_link;
			helpModuleEnabled = finalObj.showhelp;
			helpEditEnabled = finalObj.enablehelpedit;

			// ShouldShowNotificationPermission();
		},
		view: (v) => {
			// console.log({isloggedin});
			return [
				// m(PrasoraSplash),
				m(fileuploadcounter),
				helpModuleEnabled && [
					showhelpsection &&
						m(helpcomp, {
							helpEditEnabled,
							pagecode: pagecode,
							onstartrecording: () => {
								showhelpsection = false;
								recorder.start();
							},
							onclose: () => {
								showhelpsection = false;
							},
						}),
					showplayerreview &&
						m(player, {
							events: recordedevents,
							new: true,
							onstop: () => {
								showplayerreview = false;
								recordedevents = null;
							},
						}),
				],
				sharingIsOn &&
					m(".share-modal-option-wrapper", [
						m(".share-modal-option-content", [
							m(
								".title",
								{
									style: "grid-column: span 3;",
								},
								"Please share your message for Prasora"
							),
							m("textarea.content", {
								selected: true,
								style: `grid-column: span ${sharedCanvas ? "1" : "3"};`,
								value: shareMessage,
								oninput: (e) => {
									shareMessage = e.target.value;
								},
								tabindex: 1,
							}),
							sharedCanvas &&
								m(
									".image",
									{
										style: "grid-column: span 2;",
									},
									[
										m("img", {
											src: sharedCanvas,
										}),
										//m(drawableCanvas),
									]
								),
							m(
								"button",
								{
									style: "grid-column: 2 span;",
									disabled: !shareMessage,
									type: "button",
									onclick: (e) => {
										//sharingMessage = true;
										sharingIsOn = false;
										m.redraw();
										pf.APIAction("SharePageWithPrasora", {
											url: window.location.href,
											image: sharedCanvas && sharedCanvas.replace("data:image/jpeg;base64,", ""),
											message: shareMessage,
										})
											.then((r) => {
												// sharingMessage = false;
												pf.Inform("Sent!!");
												shareMessage = null;
												sharedCanvas = null;
												//sharingIsOn = false;
												m.redraw();
											})
											.catch((err) => {
												console.log(err);
												pf.Inform("There was some error. Please try sharing again.", true);
											});
									},
								},
								"Share"
							),
							m(
								"button",
								{
									style: "grid-column: 1 span;",
									type: "button",
									onclick: (e) => {
										shareMessage = null;
										sharedCanvas = null;
										sharingIsOn = false;
										m.redraw();
									},
								},
								"Cancel"
							),
						]),
					]),
				m(".prasora-header-bar", [
					m(
						".left-side",
						isloggedin &&
							m(
								"a.left-side-link",
								{
									// onclick: () => {
									//     showfullmenu = !showfullmenu;
									// },
									href: homepagelink,
								},
								[
									m(".client-name", [
										Array.from(segmenter.segment(client || "prasora")).map((a) => m("span", a.segment)),
									]),
									// m(
									// 	"svg",
									// 	{viewbox: "0 0 600 18", style: `height: 3.5rem; width: 600px;`},
									// 	m(
									// 		"text",
									// 		{
									// 			x: "0",
									// 			y: "30",
									// 			stroke: "transparent",
									// 			fill: "white",
									// 			"font-family": "Roboto Condensed",
									// 			"font-weight": "100",
									// 		},
									// 		client || "prasora"
									// 	)
									// ),
									m(".powered-by-prasora", ["  ", m("span.logo-text", "prasora"), ` inside ${localmode || ""}`]),
								]
							)
						// isloggedin &&
						// showfullmenu &&
						// m(FullHomeMenu, {
						//     homedata: homedata,
						// })
					),
					m(
						".middle-side",
						{
							onclick: (e) => {
								console.log({e});
								if (e.altKey && e.ctrlKey && e.shiftKey) {
									console.log("colorpicker");
									showcolorpicker = !showcolorpicker;
								}
							},
						},
						m(
							"a",
							{
								// href: homepagelink,
								class: !!client ? "non-prasora" : "prasora",
							},
							!isloggedin && (client || "prasora")
							// !isloggedin && m(".powered-by-prasora", ["  ", m("span.logo-text", "prasora"), " inside"])
						)
					),
					m(
						".right-side",
						{
							style: sharingIsOn ? "display: none;" : "",
						},
						[
							isloggedin && [
								m("div"),
								m("div"),
								// m(
								// 	"a.menu-icon.visible-icon",
								// 	{
								// 		class: `${allow_notification ? "notification-icon" : ""} ${showMenu ? "" : "active"}`,
								// 		href: allow_notification ? notification_link : null,
								// 	},
								// 	[
								// 		m(svg, {
								// 			name: allow_notification ? "bell" : "blank",
								// 		}),
								// 		allow_notification &&
								// 			pf.unreadnotifications() > 0 &&
								// 			m(".unread_notifications", pf.unreadnotifications()),
								// 	]
								// ),
								m(
									".menu-icon",
									{
										class: showMenu ? "" : "active",
										onclick: () => {
											showMenu = !showMenu;
										},
									},
									[
										m(svg, {
											name: "burger",
										}),
									]
								),
								m(
									".menu-icon",
									{
										class: showMenu ? "active" : "",
										onclick: () => {
											showMenu = !showMenu;
										},
									},
									[
										m(svg, {
											name: "delete",
										}),
									]
								),
								m(
									".prasora-menu-container",
									{
										"data-html2canvas-ignore": "true",
										class: showMenu ? "active" : "",
									},
									[
										helpModuleEnabled && [
											m(".record-section", [
												m(
													"a.record-icon",
													{
														onclick: (e) => {
															showMenu = false;
															if (recorder.recording()) {
																recorder.end().then((e) => {
																	if (e) {
																		// console.log({e});
																		recordedevents = e;
																		showplayerreview = true;
																		m.redraw();
																	}
																});
															} else {
																showhelpsection = true;
															}
														},
													},
													[
														m(
															".help-icon",
															{
																class: recorder.recording() ? "recording" : "",
																title: recorder.recording() ? "Stop Recording" : "Help Section",
															},
															[
																m(svg, {
																	name: recorder.recording() ? "stop-icon" : "help",
																}),
															]
														),
													]
												),
											]),
										],
										menu.map((a) => {
											return m(dropdownmenu, {
												el: a,
												OnShare: OnShare,
											});
										}),
									]
								),
							],
						]
					),
				]),
				shownotificationrequest &&
					m(
						".notification-request-wrapper",
						m(".notificaton-request", [
							m(".sub-title", "New Feature"),
							m(".title", "Alert Notifications"),
							m(
								".message",
								`Hi. We have added alert notifications to the portal. In order to receive important notifications, 
                                please go to notification section (bell icon) in top menu and click on "Allow Notifications". You will only 
                                receive notifications that are related to you and are mandated by management.`
							),
							m(".actions", [
								m(
									".button.intended",
									{
										// type: "button",
										onclick: () => {
											window.location.href = notification_link;
											ShouldShowNotificationPermission(true, 1 * 60 * 1000);
										},
									},
									"Click here to go to Notification Page"
								),
								m(
									".button",
									{
										// type: "button",
										onclick: () => {
											ShouldShowNotificationPermission(true);
										},
									},
									`Remind me in a few Days`
								),
							]),
						])
					),
				showcolorpicker &&
					m(
						".hsl-picker-wrapper",
						{
							style: `position: fixed;
    left: 20%;
    top: 20%;
    padding: 2rem;
	display: flex;
	gap: 2rem;`,
						},
						m(hslcolorpicker, {suffix: "--brand-color"}),
						m(hslcolorpicker, {suffix: "--accent-color"})
					),
			];
		},
	};
};

let dropdownmenu = () => {
	let ShareOption = false;
	let ClearCacheOption = false;

	return {
		oninit: (v) => {
			ShareOption = v.attrs.el.caption == "Share this Page with Prasora";
			ClearCacheOption = v.attrs.el.caption == "Logout";
			// console.log("there is a share option");
		},
		view: (v) => {
			return m(
				".prasora-menu-item",
				{
					href: v.attrs.el.link,
				},
				[
					m(
						"a.prasora-menu-caption",
						{
							href: v.attrs.el.link,
							//id: v.attrs.el.caption == "Share this Page with Prasora" ? "menuLink_Share_this_Page_with_Prasora" : null
							onclick: (e) => {
								// console.log("clicked");
								if (ShareOption) {
									// console.log("clicked has sharing");
									if (v.attrs.OnShare) {
										// console.log("has OnShare");
										v.attrs.OnShare();
									}
								}
								if (ClearCacheOption) {
									ClearEverything();
								}
							},
						},
						[v.attrs.el.caption]
					),
					v.attrs.el.submenu &&
						v.attrs.el.submenu.length > 0 &&
						m(".prasora-menu-submenu", [
							v.attrs.el.submenu.map((a) => {
								return m(dropdownmenu, {
									el: a,
									OnShare: v.attrs.OnShare,
								});
							}),
						]),
				]
			);
		},
	};
};

let FullHomeMenu = () => {
	let groups = [
		{
			name: "dashboard",
			caption: "Dashboard",
		},
		{
			name: "activities",
			caption: "Activities",
		},
		{
			name: "viewnodes",
			caption: "View Data",
		},
		{
			name: "addnodes",
			caption: "Add New",
		},
		{
			name: "reports",
			caption: "Reports",
		},
		{
			name: "pdfs",
			caption: "PDFs",
		},
	];

	let currentTab = "dashboard";

	return {
		view: (v) => {
			let homedata = v.attrs.homedata;

			return m(
				RC,
				{
					class: "prasora-home-page-menu",
				},
				[
					m(".content", [
						m(".tab-links", [
							groups.map((a) => {
								return m(
									"a.tab-link",
									{
										class: a.name == currentTab ? "active" : "",
										onclick: (_) => {
											currentTab = a.name;
										},
									},
									a.caption
								);
							}),
						]),
						m(".tab-sections", [
							groups.map((a) => {
								let data = [];
								data = homedata[a.name];
								console.log(data);
								return m(
									".tab-section",
									{
										class: a.name == currentTab ? "active" : "",
									},
									[
										m(
											"a.tab-section-title",
											{
												class: a.name == currentTab ? "active" : "",
												onclick: (_) => {
													currentTab = a.name;
												},
											},
											a.caption
										),
										m(".links", [
											data.map((l) => {
												return m(
													"a.homepage-link",
													{
														href: l.link,
													},
													l.caption
												);
											}),
										]),
									]
								);
							}),
						]),

						// m(
						//     ".tab-links",
						//     groups.map((a) => {
						//         return [
						//             m(
						//                 ".tab-link", {
						//                     class: a.name == currentTab ?
						//                         "active" : "",
						//                     onmouseover: (e) => {
						//                         currentTab = a.name;
						//                     },
						//                 },
						//                 a.caption
						//             ),
						//         ];
						//     })
						// ),
						// m(".tab-sections", [
						//     groups.map((a) => {
						//         return [
						//             m(
						//                 ".tab-section", {
						//                     class: a.name == currentTab ?
						//                         "active" : "",
						//                 },
						//                 [
						//                     m(() => {
						//                         return {
						//                             view: () => {
						//                                 if (
						//                                     a.name == "dashboard" ||
						//                                     a.name == "reports" ||
						//                                     a.name == "pdfs" ||
						//                                     a.name == "viewdata" ||
						//                                     a.name == "addnew"
						//                                 ) {
						//                                     let data = [];

						//                                     if (a.name == "dashboard")
						//                                         data = homedata.dashboard;
						//                                     if (a.name == "reports")
						//                                         data = homedata.reports;
						//                                     if (a.name == "pdfs")
						//                                         data = homedata.pdfs;
						//                                     if (a.name == "viewdata")
						//                                         data = homedata.viewnodes;
						//                                     if (a.name == "addnew")
						//                                         data = homedata.addnodes;

						//                                     return [
						//                                         data.map(
						//                                             (a) => {
						//                                                 return m(
						//                                                     "a.homepage-link-button", {
						//                                                         href: a.link,
						//                                                     },
						//                                                     a.caption
						//                                                 );
						//                                             }
						//                                         ),
						//                                     ];
						//                                 }

						//                                 return a.caption;
						//                             },
						//                         };
						//                     }),
						//                 ]
						//             ),
						//         ];
						//     }),
						// ]),
					]),
				]
			);
		},
	};
};
